import { iDataProyectosResultadoMap } from "../../interfaces/UmmiaApps/iDataProyectosResultadoMap";

export const SortedDataPlanificaciones = (data: iDataProyectosResultadoMap[], orderBy: string, order: string) => {
  return [...data].sort((a, b) => {
    const aValue = (a as any)[orderBy];
    const bValue = (b as any)[orderBy];

    if (!aValue || !bValue) {
      console.log("Valor no encontrado para la propiedad:", orderBy, { aValue, bValue });
      return 0;
    } // Evita errores si la propiedad no existe

    if (orderBy === "fechaCreacion") {
      return order === "asc" ? new Date(a.fechaCreacion).getTime() - new Date(b.fechaCreacion).getTime() : new Date(b.fechaCreacion).getTime() - new Date(a.fechaCreacion).getTime();
    }
    if (orderBy === "titulo" || orderBy === "nivel" || orderBy === "tipoEstructura") {
      console.log({ a, b });
      return order === "asc" ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
    }
    if (orderBy === "calificacion") {
      return order === "asc" ? a.calificacion - b.calificacion : b.calificacion - a.calificacion;
    }
    // Por defecto, esto retorna el más recientes primero
    return new Date(b.fechaCreacion).getTime() - new Date(a.fechaCreacion).getTime();
  });
};
